var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
import { DateFormats } from '../../contracts/types';
import { FlightLeg } from '../../util/flight/flightLeg';
import { currentTripStateIdVar } from '../search/currentTripState';
import { flightDetailsFragment } from './useFlightFromTrip';
const BACKGROUND_FLIGHT_SEARCH_MUTATION = gql `
    ${flightDetailsFragment}
    mutation BackgroundFlightSearchMutation(
        $estabId: Int!
        $tripStateId: ID!
        $boardTypeFilter: [Int!]
        $departureDateFormat: DateFormats
        $timeFormat: DateFormats
    ) {
        backgroundFlightSearch(tripStateId: $tripStateId, estabId: $estabId, boardTypeFilter: $boardTypeFilter) {
            requestTripStateId
            tripState {
                ...FlightDetails
            }
            flight {
                inboundLeg {
                    ${FlightLeg}
                }
                outboundLeg {
                    ${FlightLeg}
                }
            }
        }
    }
`;
export function useBackgroundFlightSearch(sideEffects, errorSideEffects) {
    var _a;
    const tripStateId = (_a = currentTripStateIdVar()) !== null && _a !== void 0 ? _a : '';
    const [backgroundFlightSearchMutation, backgroundFlightSearchResult] = useMutation(BACKGROUND_FLIGHT_SEARCH_MUTATION, {
        onError: (err) => {
            callSideEffects(errorSideEffects, err);
        },
        onCompleted: (data) => {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.backgroundFlightSearch) === null || _a === void 0 ? void 0 : _a.requestTripStateId) === tripStateId) {
                callSideEffects(sideEffects, data);
            }
        },
    });
    const backgroundFlightSearch = (args) => __awaiter(this, void 0, void 0, function* () {
        yield backgroundFlightSearchMutation({
            variables: {
                estabId: args.estabId,
                tripStateId: args.tripStateId,
                boardTypeFilter: args.boardTypeFilter,
                departureDateFormat: DateFormats.Fulldate,
                timeFormat: DateFormats.Time,
            },
        });
    });
    return [backgroundFlightSearch, backgroundFlightSearchResult];
}
